import { UserScopedVersionableStorageManagerSync } from '@bridebook/toolbox/src/storage-managers/managers/user-scoped-versionable-storage-manager-sync';
import { getCurrentUserId } from '@bridebook/web/lib/users/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { useCallback, useEffect, useState } from 'react';

// Kept in the browser per user
const storage = UserScopedVersionableStorageManagerSync<{ opened: true }>({
  storageKey: 'ai-planner-opened',
  version: '1',
});

/**
 * Whether the couple has opened the planner at least once. Until they do, the
 * entry point greets them on each visit. Counts as opened until the stored
 * flag is read after mount, so a returning couple never sees the greeting flash.
 */
export const usePlannerOpened = () => {
  const uid = useSelector(getCurrentUserId);
  const [hasOpened, setHasOpened] = useState(true);

  useEffect(() => {
    if (uid) setHasOpened(Boolean(storage.get(uid)?.opened));
  }, [uid]);

  const markPlannerOpened = useCallback(() => {
    if (!uid) return;
    storage.set({ opened: true }, uid);
    setHasOpened(true);
  }, [uid]);

  return { hasOpenedPlanner: hasOpened, markPlannerOpened };
};
